"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.O3Wallet = void 0;
const amino_1 = require("@cosmjs/amino");
const constant_1 = require("../../constant");
const index_1 = require("../../index");
const generic_1 = require("../../util/generic");
const Neon = __importStar(require("@cityofzion/neon-core-next"));
const neo_dapi_1 = __importDefault(require("neo-dapi"));
const neo3_dapi_1 = __importDefault(require("neo3-dapi"));
const util_1 = require("../../util");
const O3Types = __importStar(require("./O3Types"));
class O3Wallet {
    constructor(network) {
        this.network = network;
        this.address = "";
        this.publicKey = "";
        const networkConfig = constant_1.NetworkConfigs[network];
        this.networkConfig = networkConfig;
        this.neo2Dapi = neo_dapi_1.default;
        this.neo3Dapi = neo3_dapi_1.default;
    }
    static instance(opts) {
        const { network } = opts;
        return new O3Wallet(network);
    }
    assembleSigner(bech32Address, pubKey) {
        const dapi = this.getDAPI();
        return {
            type: index_1.CarbonSignerTypes.BrowserInjected,
            signAmino: (_, doc) => __awaiter(this, void 0, void 0, function* () {
                const msg = JSON.stringify((0, generic_1.sortObject)(doc));
                const signBytes = yield dapi.signMessage(msg);
                const signature = (0, amino_1.encodeSecp256k1Signature)(pubKey, signBytes);
                return {
                    signed: doc,
                    signature,
                };
            }),
            getAccounts: () => __awaiter(this, void 0, void 0, function* () {
                return [
                    {
                        algo: "secp256k1",
                        address: bech32Address,
                        pubkey: pubKey,
                    },
                ];
            }),
        };
    }
    connectWallet() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const publicKeyOutput = yield this.getPublicKeyOutput();
                this.address = publicKeyOutput.address;
                this.publicKey = publicKeyOutput.publicKey;
                return publicKeyOutput;
            }
            catch (err) {
                const type = (_a = err.type) !== null && _a !== void 0 ? _a : "";
                throw new Error((_c = type !== null && type !== void 0 ? type : (_b = err) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "");
            }
        });
    }
    disconnectWallet() {
        this.address = "";
        this.publicKey = "";
        this.neoNetwork = undefined;
    }
    isConnected() {
        return this.address !== "";
    }
    lockDeposit(lockParams) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { token, amount, feeAmount, toAddress, fromAddress } = lockParams;
            try {
                if (this.publicKey === "") {
                    throw new Error("O3 wallet is not connected. Please reconnect and perform this transaction again.");
                }
                const scriptHash = Neon.u.reverseHex(token.bridgeAddress);
                const tokenScriptHash = Neon.u.reverseHex(token.tokenAddress);
                const nonce = Math.floor(Math.random() * 1000000);
                const scriptHashAccount = this.neoNetwork === "N3MainNet"
                    ? util_1.AddressUtils.N3Address.publicKeyToScriptHash(this.publicKey)
                    : util_1.AddressUtils.NEOAddress.publicKeyToScriptHash(this.publicKey);
                const args = [
                    { type: O3Types.ArgTypes.Hash160, value: tokenScriptHash },
                    { type: O3Types.ArgTypes.Hash160, value: fromAddress },
                    { type: O3Types.ArgTypes.ByteArray, value: toAddress },
                    { type: O3Types.ArgTypes.Integer, value: amount.toString(10) },
                    { type: O3Types.ArgTypes.Integer, value: feeAmount.toString(10) },
                    { type: O3Types.ArgTypes.ByteArray, value: Neon.u.HexString.fromHex(this.networkConfig.feeAddress, true) },
                    { type: O3Types.ArgTypes.Integer, value: nonce.toString() },
                ];
                const signers = [{
                        account: scriptHashAccount,
                        scopes: 16,
                    }];
                const output = yield this.assembleAndInvoke("lock", scriptHash, args, false, signers);
                return output;
            }
            catch (err) {
                const type = err.type;
                throw new Error((_b = type !== null && type !== void 0 ? type : (_a = err) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "");
            }
        });
    }
    assembleAndInvoke(operation, scriptHash, args, broadcastOverride = false, signers) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const dApi = this.getDAPI();
                const invokeMsg = Object.assign({ scriptHash,
                    operation,
                    args, network: this.neoNetwork, broadcastOverride: broadcastOverride }, this.neoNetwork === "N3MainNet" && { signers });
                return dApi.invoke(invokeMsg);
            }
            catch (err) {
                const type = err.type;
                throw new Error((_b = type !== null && type !== void 0 ? type : (_a = err) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "");
            }
        });
    }
    getWalletBalances(tokens) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.isConnected()) {
                    throw new Error("O3 wallet is not connected. Please reconnect and perform this transaction again.");
                }
                const tokenMap = tokens.reduce((tokens, indivToken) => {
                    const newTokens = tokens;
                    const tokenAddress = indivToken.tokenAddress;
                    newTokens[tokenAddress] = indivToken;
                    return newTokens;
                }, {});
                const argsBalance = {
                    params: [{
                            address: this.address,
                            contracts: Object.keys(tokenMap).map((token) => `0x${token}`),
                        }],
                };
                const dapi = this.getDAPI();
                const response = yield dapi.getBalance(argsBalance);
                const balanceMap = {};
                const balances = response[this.address];
                balances.forEach((balance) => {
                    var _a, _b;
                    const assetId = (_b = (_a = balance.assetID) === null || _a === void 0 ? void 0 : _a.replace('0x', '')) !== null && _b !== void 0 ? _b : balance.contract.replace('0x', '');
                    const tokenContract = Neon.u.reverseHex(assetId);
                    const tokenInfo = tokenMap[tokenContract];
                    if (!tokenInfo) {
                        return;
                    }
                    balanceMap[tokenInfo.denom] = Object.assign(Object.assign({}, tokenInfo), { externalBalance: balance.amount });
                });
                return balanceMap;
            }
            catch (err) {
                const type = err.type;
                throw new Error((_b = type !== null && type !== void 0 ? type : (_a = err) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "");
            }
        });
    }
    getNetworks() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.neo3Dapi.getNetworks();
        });
    }
    getPublicKeyOutput() {
        return __awaiter(this, void 0, void 0, function* () {
            const dapi = this.getDAPI();
            return dapi.getPublicKey();
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const dapi = this.getDAPI();
            return dapi.getAccount();
        });
    }
    getDAPI() {
        return this.neoNetwork === "N3MainNet" ? this.neo3Dapi : this.neo2Dapi;
    }
    setNetwork(network) {
        if (network === "N3MainNet" || network === "MainNet") {
            this.neoNetwork = network;
        }
        else {
            this.neoNetwork = undefined;
        }
    }
}
exports.O3Wallet = O3Wallet;
exports.default = O3Wallet;
